/**
 * Experiment to improve the speed when user navigate to next page through pagination
 */
export const CATNAV_PAGINATION_CHANGE_SPEED_EXPERIMENT_240604 = 'CATNAV_PAGINATION_CHANGE_SPEED_EXPERIMENT_240604';
